import React from "react";
import Grid from "@mui/material/Grid2";
import { Typography, Box } from "@mui/material";
import productDetail1 from "../../../images/productDetail1.png";
import soluSliderGradCircle from "../../../assets/icons/soluSliderGradCircle.svg";
import RainWaterImage from "../../../images/sh700.png";
import { useParams } from "react-router-dom";

const ApplicationsBlockRTL: any = (props: any) => {
  const { pageData } = props;

  const { type } = useParams();

  return (
    <Box
      pt={2}
      sx={{
        zIndex: 1,
        position: "relative",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        backgroundPosition: "inherit",
        width: "100%",
      }}
    >
      <Grid
        container
        sx={{
          flexGrow: 1,
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          padding: { xs: "5px", sm: "5px", md: "0px" },
          width: "100%",
          alignItems: "center",
        }}
      >
        {/* Image section - Now on the left */}
        <Grid
          size={{ xs: 12, sm: 12, md: 6, lg: 6 }}
          sx={{
            position: "relative",
            display: "flex",
            alignItems: "center",
            order: { xs: 1, md: 2 },
            paddingBottom: { xs: "20px", md: 0 },
            justifyContent: "center",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-around",
              zIndex: 2,
              position: "relative",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Box
              sx={{
                padding: 2,
                maxWidth: 600,
                width: "100%",
                objectFit: "contain",
              }}
            >
              <Typography
                variant="h4"
                component="h2"
                fontWeight="bold"
                sx={{
                  color: "#3A00E5",
                  mb: 2,
                  textAlign: { xs: "center", md: "center" },
                }}
              >
                {pageData?.solutionsDetails?.blogBlock1?.primaryText}
              </Typography>
            </Box>
            <Box
              sx={{
                padding: 2,
                maxWidth: 600,
                width: "100%",
                objectFit: "contain",
              }}
            >
              {" "}
              <Typography
                variant="body1"
                sx={{
                  color: "#0A1A3C",
                  fontSize: "18px",
                  lineHeight: 1.6,
                  textAlign: { xs: "center", md: "center" },
                }}
              >
                {pageData?.solutionsDetails?.blogBlock1?.secondaryText}
              </Typography>
            </Box>
          </Box>
        </Grid>

        {/* Application text section - Now on the right */}
        <Grid
          size={{ xs: 12, sm: 12, md: 6, lg: 6 }}
          sx={{
            padding: { xs: "20px", md: "40px" },
            order: { xs: 1, md: 2 }, // Adjusted order for md and larger screens
            position: "relative", // Establish a positioning context for absolute elements
          }}
        >
          <Box
            className="soluSliderGradCircle"
            sx={{
              position: "absolute", // Position it relative to the Grid
              zIndex: "1", // Bring it on top of the productDetail1 image
              left: { xs: "180px", sm: "319px", md: "310px", lg: "385px" },
              transform: "translateX(-50%)", // Ensure proper horizontal alignment
              height: { xs: 67, sm: 67, md: 67, lg: 200 }, // Adjust size for responsiveness
              width: { xs: "50%", sm: "30%", md: "52%", lg: "52%" },
              top: { xs: "20px", sm: "20px", md: "47px", lg: "47px" }, // Adjust its vertical placement
            }}
          >
            <img
              src={soluSliderGradCircle}
              width={"100%"}
              alt="soluSliderGradCircle"
            />
          </Box>

          <Box
            component="img"
            src={type === "storm" ? productDetail1 : RainWaterImage}
            alt="Application 1"
            //  src={
            //   pageData?.solutionsDetails?.blogBlock1?.media?.[0]?.url
            //     ? process.env.REACT_APP_API_BASE_URL +
            //       pageData?.solutionsDetails?.blogBlock1?.media?.[0]?.url
            //     : productDetail1
            // }
            sx={{
              padding: 2,
              // maxWidth: 600,
              height: { xs: "287px", sm: "287px", md: "420px", lg: "420px" },
              maxHeight: { xs: "287px", sm: "287px", md: "534px", lg: "534px" },
              width: {
                xs: "100%",
                sm: "100%",
                md: "500.38px",
                lg: "681.38px",
                xl: "681.38px",
              },
              position: "relative",
              zIndex: "1",
              maxWidth: {
                xs: "100%",
                sm: "100%",
                md: "681.38px",
                lg: "681.38px",
                xl: "681.38px",
              },
            }}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default ApplicationsBlockRTL;
